import { styled as t } from "@lokalise/styled";
import { value as i, spacing as o } from "../../utils/theme/index.js";
const n = t.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
`, d = t.div`
	width: 100%;
	background: ${i("color.border.light")};
	height: 1px;
	margin-top: ${o(1)};
`;
export {
  n as ActionsContainer,
  d as HorizontalDivider
};
//# sourceMappingURL=styles.js.map
